import { render, staticRenderFns } from "./messageEditor.vue?vue&type=template&id=6248bab3&scoped=true&"
import script from "./messageEditor.vue?vue&type=script&lang=js&"
export * from "./messageEditor.vue?vue&type=script&lang=js&"
import style0 from "./messageEditor.vue?vue&type=style&index=0&id=6248bab3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6248bab3",
  null
  
)

export default component.exports